import { render, staticRenderFns } from "./katalogPerpusDetile.vue?vue&type=template&id=a43e3032&"
import script from "./katalogPerpusDetile.vue?vue&type=script&lang=js&"
export * from "./katalogPerpusDetile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QDialog,QCard,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QDialog,QCard,QImg})
